<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <a href="/sync">Sync</a> /
      <span> Complete </span>
    </nav>
    <sync-steps :method="queryData.method"></sync-steps>

    <div class="container mt-5">
      <h2 class="flow-heading mt-5">Hooray! Your sync was successful!</h2>
      <p class="flow-subheading sync-complete__subheading mt-4 mb-5">
        <template v-if="queryData.method === 'groups'">
          <strong>{{ queryData.groups }}</strong> groups
        </template>
        <template v-else>
          <strong>{{ queryData.contacts }}</strong> contacts
        </template>
        have been successfully synced.
      </p>
      <div>
        <a class="btn btn-lg btn-outline-primary mr-2 mb-2" href="/inventory/contacts/groups/">View Contacts</a>
        <a class="btn btn-lg btn-primary mb-2" href="/sync/management">Go to Sync Management</a>
      </div>
    </div>
  </div>
</template>

<script>
import SyncSteps from '../components/sync/SyncSteps';

export default {
  name: 'sync-complete-page',
  components: {SyncSteps},
  props: {
    vessel: {
      type: String,
      required: true,
    },
  },
  computed: {
    urlSearchParams() {
      return new URLSearchParams(window.location.search);
    },
    queryData() {
      const {contacts, groups, method} = Object.fromEntries(this.urlSearchParams.entries());
      return {contacts, groups, method};
    },
    vesselName() {
      return JSON.parse(this.vessel).name;
    },
  },
};
</script>

<style lang="scss" scoped>
.sync-complete {
  &__img {
    margin: 30px auto;
  }
  &__subheading {
    font-weight: normal;
  }
}
</style>
